import React, { useState, useEffect, useRef } from 'react'

const DashPE = () => {
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const iframeRef = useRef(null);
    let width = window.innerWidth * (98.5 / 100);
    let tempHeight = window.innerHeight;
    let headerHeight = (9 / 100) * tempHeight;
    let height = tempHeight - headerHeight

    return (
        <>
            <iframe title="Report Section" ref={iframeRef}
                width={width}
                height={tempHeight}
                src="https://app.powerbi.com/view?r=eyJrIjoiZDUwNDVkZGYtNTdhZS00YjM3LWJiZmItYzg4Y2Y4MTk2NTc5IiwidCI6IjNjNjE5YTUwLWM2OGMtNGQ1OC1iMmQ3LWY0NDAyNTYwYWYyYyJ9"
                frameborder="0"
                allowFullScreen="true"
            ></iframe>
        </>
    )
}

export default DashPE
